import React from 'react';
import {notification} from 'antd';
import { UserOutlined,TeamOutlined } from '@ant-design/icons';

import _ from 'lodash';
import Language from 'components/language';



const URL = process.env.REACT_APP_API_STATICURL;

export const getStatic=(id,type,fileType)=>fileType=="gif"?`${URL}/${type}/${id}.${fileType}`:defaultImage;


export const to = (promise)=>(promise.then(data => [null, data]).catch(err => [err]));
export const wait = (seconds)=>new Promise((resolve) =>setTimeout(() => resolve(), seconds*1000));
export const splitFileName=(filename)=> {const name=filename.replace(/\..+$/, '');const fileType = filename.split('.').pop();return {name,fileType} };
export const showError=(err,message)=>notification.error({message:"Unsupported file format/Format de fichier non supporté",description:err.response?err.response.data.Error:err.toString()});

export const defaultImage="data:image/png;base64,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";
export const capitalizeFirstLetter=(str)=>str&&str.length>0?str[0].toUpperCase() + str.slice(1):str;
export const getIsAdmin=(user)=>{  
  if(!user)return false;
  const groups=user.signInUserSession.accessToken.payload["cognito:groups"]; 
  return groups && groups.includes("Admin");
}
export const isImage=(x)=>x&&["jpeg","jpg", "gif", "png", "apng", "svg", "avif", "webp"].includes(x.toLowerCase());
export const isVideo=(x)=>x&&["mp4","webm", "ogg"] .includes(x.toLowerCase());


const fetchWait =async({fetch,resolve,reject,time,progressCallback=()=>null,cancel})=>{  
  // console.log("fetchWait")
  
  const [err,response] = await to(fetch());
  if(err)return reject(err);
  const {status,error}=response;
  if(status=="COMPLETE")return resolve(response);
  if(status=="FAILED")return reject(new Error(error));  
  progressCallback(response)
  time.seconds +=1;
  // console.log(time.seconds)
  if(cancel && cancel())return reject(new Error("FAILED : cancelled"))
  if (time.seconds >= time.maxSeconds)return reject(new Error("FAILED : Took longer than 60seconds")); 
}


export const waitJob2=(fetch,progressCallback,cancel)=>new Promise((_resolve, _reject)=>{  
  const  resolve=(response)=>clearInterval(intervalId)||_resolve(response)
  const  reject=(error)=>clearInterval(intervalId)||_reject(error)
  
  const time = {seconds:0,maxSeconds:60};
  let intervalId = setInterval(() => fetchWait({fetch,intervalId,resolve,reject,time,progressCallback,cancel}), 1000);  
}) 

export const extensionToLanguage = {
    'js': 'javascript',
    'py': 'python',
    'json': 'json',   
    'md':'Markdown',
    'txt':'plaintext',
    'job': 'json',
    'jobTemplate': 'json',   
    'jobtemplate': 'json',   
    // Add more mappings here
};
export const editableFiles=Object.keys(extensionToLanguage);


export const getProfilePicture=(user)=>{
  if(!user)return {icon:<TeamOutlined />};
  const picture = user?.picture;  
  return  picture?{src:picture}:
  user?.id?.includes("team-")?{icon:<TeamOutlined />}:
  {icon:<UserOutlined />};
};


export const getItemMeta=(data)=>{
  return (data && data.data && data.data.length==1)?data.data[0].meta:undefined;
};




export const sortString = (a, b) => {
  const nameA = a.toUpperCase(); // ignore upper and lowercase
  const nameB = b.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB)return -1;  
  if (nameA > nameB)return 1; 
  return 0;
};


export const tryParse=(str)=>{
  try{
    const a=JSON.parse(str);
    return [null,a]
    }
  catch(e){return [e,{}]};
}
export const trycatch=(f)=>{
  try{
     const response=f();     
     return [null,response]
  }
  catch(e){    
    return [e,null]
  }
   
}

// Hook
export const usePrevious=(value)=>{
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = React.useRef();
  // Store current value in ref
  React.useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
/* eslint-disable react-hooks/rules-of-hooks */
export const callState =(_value,callback)=>{
  
  const [value,setValue] = React.useState(_value);  
  const useEffect = (props)=>React.useEffect(() => {       
    if(!_.isEqual(value,_value)){        
      setValue(_value);
      if(callback)callback(props); 
    }
  },[_value]);
  return useEffect;
};
/* eslint-disable react-hooks/rules-of-hooks */

export const useParentState =(_value,_setValue)=>{  
  
  const [__value,__setValue] = React.useState(_value);  
  

  const value = _setValue?_value: __value;
  const setValue = _setValue?_setValue: __setValue;  
  return [value,setValue];
};



export const waitJob3=({fetch,progress})=>{      
  let intervalId = setInterval(async() => {    
    progress(await to(fetch()))
    }, 1000);  
  return intervalId
}; 

const fetchWait2 =async({fetch,progressCallback=()=>null})=>{  
  // console.log("fetchWait")
  
  const [err,response] = await to(fetch());
  
  
  
}

export const getSafeJSON = (value1,value2)=>{
    
    const [err1,v1] = tryParse(value1)        
    if(!err1)return v1;    
    const [err2,v2] = tryParse(value2)            
    if(!err2)return v2;       
    return {};         
  };

  

export const getRowSelection = ({key,data:_data,setData,type="checkbox"})=>{        
  if(!_data)return {}
  const data = _data.map(o=>({...o,[key]:_.isArray(o[key])?o[key]:[o[key]]}));
  const uniqueKeys = [...new Set(data.reduce((acc,curr)=>[...acc,...curr[key]],[]))];
  
  const selectedRowKeys=uniqueKeys.filter(uniqueKey=>data.every(o=>o[key].includes(uniqueKey)));
  
  return {
    type,
    selectedRowKeys,    
    onSelect:(record, selected, selectedRows, nativeEvent)=>{   
      if(type=="radio")return setData(data.map(o=>({...o,[key]:[record.id]})));
      selectedRowKeys.includes(record.id)?
        setData(data.map(o=>({...o,[key]:o[key].filter(o=>o !=record.id)}))):              
        setData(data.map(o=>({...o,[key]:_.union(o[key],[record.id])})));      
    },   
    getCheckboxProps: (record) => ({      
      indeterminate:selectedRowKeys.includes(record.id)?false:data.some(o=>o?.[key]&&o?.[key].includes(record.id)),      
    }),
  };
};






